import { useMutation, useQuery } from "react-query";
import { useMatch } from "react-router-dom";

import { deleteSearchHistory, getSearchRecommendation, getSearchPapers, getSearchHistory } from "utils/request/search";

const useCurrentSpaceUuid = () => {
    const match = useMatch("/:space_uuid/*");
    return match?.params?.space_uuid ?? "";
};

export const useSearchPapers = (params) => {
    const space_uuid = useCurrentSpaceUuid();
    return useQuery(["searchPapers", space_uuid, params], () => getSearchPapers(space_uuid, params), {
        staleTime: Infinity,
        cacheTime: Infinity,
        retry: false,
        keepPreviousData: true,
    });
};

export const useSearchRecommendation = (params) => {
    const space_uuid = useCurrentSpaceUuid();
    return useQuery(["searchRecommendation", space_uuid, params], (e) => getSearchRecommendation(space_uuid, params), {
        staleTime: Infinity,
        cacheTime: Infinity,
        retry: false,
    });
};

export const useSearchHistory = (params) => {
    const space_uuid = useCurrentSpaceUuid();
    return useQuery(["searchHistory", space_uuid, params], (e) => getSearchHistory(space_uuid, params), {
        staleTime: Infinity,
        cacheTime: Infinity,
        retry: false,
    });
};

export const useDeleteSearchHistory = () => {
    const space_uuid = useCurrentSpaceUuid();
    return useMutation((body) => deleteSearchHistory(space_uuid, body));
};
